import { observable, action, runInAction, toJS } from "mobx";
import * as API from "../../../api/mAppManage";
import { Dialog } from "@weapp/ui";
import { getLabel } from "@weapp/utils";
import { filterApp, inApp } from "../../../utils";
const { message } = Dialog;

class MAppManageStore {
  @observable apps: any = [];
  appsOrigin: any = [];
  @observable groupTitles: any = []; // 分组信息
  @observable selectedApps: any = [];
  @observable selectedGroups: any = []; //启用的分组

  @observable teamDisabledApps: any = [];

  @action
  init = () => {
    this.querySysUnDisplayMenus();
    this.getApps();
  };
  @action
  getApps = () => {
    API.getMobileAppModules({
      showAll: true
    }).then((data: any) => {
      if (data && data.data) {
        let apps: any = [],
          appsOrigin: any = [],
          groupTitles: any = [],
          selectedApps: any = [],
          selectedGroups: any = [];
        data.data.forEach((group: any) => {
          if (group.id && group.id !== "-1") {
            groupTitles.push({
              id: group.id,
              content: group.groupName,
              status: group.mobileStatus,
            });
            if (group.mobileStatus) {
              selectedGroups.push(group.id);
            }
            if (group.menus) {
              filterApp(group.menus).forEach((module: any) => {
                let app = {
                  id: module.menuId,
                  moduleId: module.id,
                  status: module.status,
                  shortName: module.menuname,
                  type: group.id,
                };
                apps.push(app);
                appsOrigin.push({...app});
                if (module.status) {
                  selectedApps.push(app);
                }
              });
            }
          }
        });
        runInAction(() => {
          this.apps = apps;
          this.appsOrigin = appsOrigin;
          this.groupTitles = groupTitles;
          this.selectedApps = selectedApps;
          this.selectedGroups = selectedGroups;
        });
      }

      console.log(data);
    });
  };
  @action
  updateSelectedApps = (apps: []) => {
    this.selectedApps = apps;
    this.apps.forEach((app: any) => {
      let status = this.selectedApps.some((sapp: any) => {
        return sapp.id === app.id;
      });
      console.log(status);
      app.status = status;
    });
  };

  @action
  querySysUnDisplayMenus = () => {
      API.querySysUnDisplayMenus({}).then((result: any) => {
          runInAction(() => {
              this.teamDisabledApps = result.data;
          });
      })
  }

  @action
  updateApps = (apps: []) => {
    this.apps = apps;
  };
  @action
  updateGroups = (groups: []) => {
    this.groupTitles = groups;
  };
  @action
  updateSelectedGroups = (groups: []) => {
    this.selectedGroups = groups;
  };
  @action
  updateAppDataBySortSetting = () => {
    let appDatas = [...this.apps];
    appDatas = appDatas.filter((item: any) => {
      const teamUnabled = this.teamDisabledApps.includes(item.moduleId);
      const groupEnabled = this.selectedGroups.find((it: any) => it === item.type);
      const isAdmin = window.TEAMS.currentUser?.admin;
      const status = item.status;
      let flag = true;

      if (isAdmin) {
        return groupEnabled;
      }

      if (teamUnabled) {
        flag = status;
      } else {
        flag = groupEnabled;
      }

      return flag;

    });
    this.selectedApps = [...appDatas]
  };
  @action
  resetAppModules = () => {
    API.resetEmpMobileModules().then(() => {
      this.getApps();
      if (inApp()) {
        document.cookie = `appListUpdate=update;path=/;`;
        localStorage.setItem('appListUpdate', 'update');
      }
      message({
        type: "success",
        content: getLabel('16291', "操作成功"),
      });
    });
  };
  @action
  saveAppConfig = () => {
    let appTypes: any[] = [];
    let groupOrder = 0;
    this.groupTitles.forEach((group: any) => {
      groupOrder++;
      let appModules: any[] = [];
      let appOrder = 0;
      this.apps.forEach((appInfo: any, index: number) => {
        let originApp = this.appsOrigin[index];
        if (group.id === appInfo.type) {
          appOrder++;
          const status = !!(this.selectedApps.find(((app: any) => app.id === appInfo.id)));
          appModules.push({
            moduleId: appInfo.moduleId,
            status: status,
            name: appInfo.shortName,
            orderNum: appOrder
          });
        }
      });
      let groupInfo = {
        id: group.id,
        status: this.selectedGroups.includes(group.id),
        orderNum: groupOrder,
        name: group.content,
        appModules: appModules
      };
      appTypes.push(groupInfo);
    });

    const params = { appTypes: appTypes };

    // console.log(params)
    API.saveMobileAppModules(params).then(() => {
      this.getApps();
      if (inApp()) {
        document.cookie = `appListUpdate=update;path=/;`;
        // localStorage.setItem('appListUpdate', 'update');
      }
      message({
        type: "success",
        content: getLabel('32223', "保存成功"),
      });
    });

    let displayChangeApps: any[] = [];
    this.apps.forEach((appInfo: any, index: number) => {
      let originApp = this.appsOrigin[index];
      if (originApp.id === appInfo.id && originApp.status && !appInfo.status){
        console.log(originApp,appInfo)
        displayChangeApps.push({menuid: originApp.moduleId, menuStatus: 0})
      }
    });
    //关闭禁用的应用在pc主导航显示
    displayChangeApps.length && API.savePcDisplayModules(displayChangeApps).then(({status}) => {
      if (status){

      }
    })
  };
}

const instance = new MAppManageStore();

export default instance;
